import Section from "@/components/ui/section";
import React from "react";
import Slick from "@/components/ui/carousel/slick";
import dynamic from "next/dynamic";
const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false });
export default function Stories({ data, title, slidesToShow = 2 }) {
  var responsive = [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: slidesToShow,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
      },
    },
  ];
  return (
    <Section className="">
      <h2 className="text-blue text-center mb-6">{title}</h2>
      <Slick
        responsive={responsive}
        autoplay={false}
        slidesToShow={slidesToShow}
        slidesToScroll={1}
      >
        {data?.map((row, key) => (
          <div className="flex flex-col w-full" key={"story" + key}>
            <div className="md:p-4 px-2 w-full md:h-[350px] h-52">
              <ReactPlayer
                url={row?.videoPath}
                className={`overflow-hidden bg-body object-cover [&>video]:object-cover rounded-xl`}
                playing={false}
                loop={false}
                // light={card?.image}
                // playIcon={<Overlay card={card} handlePlaying={handlePlaying} />}
                playsinline={true}
                width="100%"
                height="100%"
                controls={true}
                muted={true}
              />
            </div>
            <p className="text-center lg:text-lg text-darkBlue font-medium">
              {row?.title}
            </p>
          </div>
        ))}
      </Slick>
    </Section>
  );
}
